webpackJsonp([6],{

/***/ "/kga":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("cvA0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("92Bb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_347e3f32_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("IURv");
function injectStyle (ssrContext) {
  __webpack_require__("7zGH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_347e3f32_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "29CB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.imageFileUpload = imageFileUpload;
exports.uploadFileBase = uploadFileBase;
exports.removeImg = removeImg;
exports.queryMyElectricCar = queryMyElectricCar;
exports.insertElectrocar = insertElectrocar;
exports.queryMyElectricCarInfo = queryMyElectricCarInfo;
exports.insertRiding = insertRiding;
exports.deleteRidingById = deleteRidingById;
exports.updateLossMyCar = updateLossMyCar;
exports.cancelLossMyCar = cancelLossMyCar;
exports.queryMyScanCodePage = queryMyScanCodePage;
exports.scanCode = scanCode;
exports.detainCar = detainCar;
exports.queryMyPoliceCluePage = queryMyPoliceCluePage;
exports.getOnlyClueInfo = getOnlyClueInfo;
exports.doCluePolice = doCluePolice;
exports.updateUser = updateUser;
exports.callPolice = callPolice;
exports.qrCodeHandelValidCar = qrCodeHandelValidCar;
exports.insertElectrocarAndUser = insertElectrocarAndUser;
exports.insertIntention = insertIntention;
exports.queryGuaranteeDetailByNo = queryGuaranteeDetailByNo;

var _request = __webpack_require__("fQyU");

var _request2 = _interopRequireDefault(_request);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dPatch =  true ? '/api' : '';

// 图片上传
function imageFileUpload(data) {
    return (0, _request2.default)({
        url: dPatch + '/file/imageFileUpload',
        method: 'post',
        data: data
    });
}

// 图片上传base
function uploadFileBase(data) {
    return (0, _request2.default)({
        url: dPatch + '/file/uploadFileBase',
        method: 'post',
        data: data
    });
}

// 图片删除
function removeImg(data) {
    return (0, _request2.default)({
        url: dPatch + '/file/removeImg',
        method: 'post',
        data: data
    });
}

// 我的车-列表查询
function queryMyElectricCar(data) {
    return (0, _request2.default)({
        url: dPatch + '/wechatelectrocar/queryMyElectricCar',
        method: 'post',
        data: data
    });
}

// 我的车-添加车辆
function insertElectrocar(data) {
    return (0, _request2.default)({
        url: dPatch + '/wechatelectrocar/insertElectrocar',
        method: 'post',
        type: 'json',
        data: data
    });
}

// 电动车-详情
function queryMyElectricCarInfo(data) {
    return (0, _request2.default)({
        url: dPatch + '/wechatelectrocar/queryMyElectricCarInfo',
        method: 'post',
        data: data
    });
}

// 添加骑行人
function insertRiding(data) {
    return (0, _request2.default)({
        url: dPatch + '/riding/insertRiding',
        method: 'post',
        data: data
    });
}

// 删除骑行人
function deleteRidingById(data) {
    return (0, _request2.default)({
        url: dPatch + '/riding/deleteRidingById',
        method: 'post',
        data: data
    });
}

// 报失
function updateLossMyCar(data) {
    return (0, _request2.default)({
        url: dPatch + '/wechatelectrocar/updateLossMyCar',
        method: 'post',
        data: data
    });
}

// 取消报失
function cancelLossMyCar(data) {
    return (0, _request2.default)({
        url: dPatch + '/wechatelectrocar/cancelLossMyCar',
        method: 'post',
        data: data
    });
}

// 我的扫码列表
function queryMyScanCodePage(data) {
    return (0, _request2.default)({
        url: dPatch + '/scan/queryMyScanCodePage',
        method: 'post',
        data: data
    });
}

// 扫一扫-电动车信息
function scanCode(data) {
    return (0, _request2.default)({
        url: dPatch + '/scan/scanCode',
        method: 'post',
        data: data
    });
}

// 警务-扣车
function detainCar(data) {
    return (0, _request2.default)({
        url: dPatch + '/scan/detainCar',
        method: 'post',
        data: data
    });
}

// 线索追踪接口列表
function queryMyPoliceCluePage(data) {
    return (0, _request2.default)({
        url: dPatch + '/clueTracking/queryMyPoliceCluePage',
        method: 'post',
        data: data
    });
}

// 线索详情
function getOnlyClueInfo(data) {
    return (0, _request2.default)({
        url: dPatch + '/clueTracking/getOnlyClueInfo',
        method: 'post',
        data: data
    });
}

// 警务提交线索确认接口
function doCluePolice(data) {
    return (0, _request2.default)({
        url: dPatch + '/clueTracking/doCluePolice',
        method: 'post',
        data: data
    });
}

// 车主信息修改
function updateUser(data) {
    return (0, _request2.default)({
        url: dPatch + '/user/updateUser',
        method: 'post',
        type: 'json',
        data: data
    });
}

// 报警
function callPolice(data) {
    return (0, _request2.default)({
        url: dPatch + '/scan/callPolice',
        method: 'post',
        type: 'json',
        data: data
    });
}

// 警务加车
function qrCodeHandelValidCar(data) {
    return (0, _request2.default)({
        url: dPatch + '/wechatelectrocar/qrCodeHandelValidCar',
        method: 'post',
        type: 'json',
        data: data
    });
}
// 警务加人
function insertElectrocarAndUser(data) {
    return (0, _request2.default)({
        url: dPatch + '/wechatelectrocar/insertElectrocarAndUser',
        method: 'post',
        type: 'json',
        data: data
    });
}

// 申请合作
function insertIntention(data) {
    return (0, _request2.default)({
        url: dPatch + '/intention/insert',
        method: 'post',
        type: 'json',
        data: data
    });
}

// 查询保函详情
function queryGuaranteeDetailByNo(data) {
    return (0, _request2.default)({
        url: dPatch + '/guarantee/queryDetailByNo',
        method: 'post',
        data: data
    });
}

/***/ }),

/***/ "2RPQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _xDialog = __webpack_require__("/kga");

var _xDialog2 = _interopRequireDefault(_xDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'alert',
  components: {
    XDialog: _xDialog2.default
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value;
    }
  },

  props: {
    value: Boolean,
    title: String,
    content: String,
    buttonText: String,
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    maskZIndex: [Number, String]
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onHide: function _onHide() {
      this.showValue = false;
    }
  },
  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "2sLL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("vjYW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("TCOM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_d5f075ca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("8Uaa");
function injectStyle (ssrContext) {
  __webpack_require__("RMDY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_d5f075ca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "3iZP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4ml/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "55wj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "62KO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("7uin");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("DxUy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_c48d9308_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("TRD7");
function injectStyle (ssrContext) {
  __webpack_require__("nnSp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_c48d9308_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "7uin":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _xDialog = __webpack_require__("/kga");

var _xDialog2 = _interopRequireDefault(_xDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'confirm',
  components: {
    XDialog: _xDialog2.default
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showInput: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'ios'
    },
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    title: String,
    confirmText: String,
    cancelText: String,
    maskTransition: {
      type: String,
      default: 'vux-fade'
    },
    maskZIndex: [Number, String],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    content: String,
    closeOnConfirm: {
      type: Boolean,
      default: true
    },
    inputAttrs: Object,
    showContent: {
      type: Boolean,
      default: true
    },
    confirmType: {
      type: String,
      default: 'primary'
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    showConfirmButton: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    this.showValue = this.show;
    if (this.value) {
      this.showValue = this.value;
    }
  },

  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      var _this = this;

      this.$emit('input', val);
      if (val) {
        if (this.showInput) {
          this.msg = '';
          setTimeout(function () {
            if (_this.$refs.input) {
              _this.setInputFocus();
            }
          }, 300);
        }
        this.$emit('on-show'); // emit just after msg is cleared
      }
    }
  },
  data: function data() {
    return {
      msg: '',
      showValue: false
    };
  },

  methods: {
    getInputAttrs: function getInputAttrs() {
      return this.inputAttrs || {
        type: 'text'
      };
    },
    setInputValue: function setInputValue(val) {
      this.msg = val;
    },
    setInputFocus: function setInputFocus(evt) {
      if (evt) {
        evt.preventDefault();
      }
      this.$refs.input.focus();
    },
    _onConfirm: function _onConfirm() {
      if (!this.showValue) {
        return;
      }
      if (this.closeOnConfirm) {
        this.showValue = false;
      }
      this.$emit('on-confirm', this.msg);
    },
    _onCancel: function _onCancel() {
      if (!this.showValue) {
        return;
      }
      this.showValue = false;
      this.$emit('on-cancel');
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "7zGH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8Uaa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"weui-btn",class:_vm.classes,style:(_vm.buttonStyle),attrs:{"disabled":_vm.disabled,"type":_vm.actionType},on:{"click":_vm.onClick}},[(_vm.showLoading)?_c('i',{staticClass:"weui-loading"}):_vm._e(),_vm._v(" "),_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "92Bb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _preventBodyScroll = __webpack_require__("JkZY");

var _preventBodyScroll2 = _interopRequireDefault(_preventBodyScroll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_preventBodyScroll2.default],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "9P88":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__("woOf");

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var wechatAuth = function () {
    function wechatAuth(config) {
        (0, _classCallCheck3.default)(this, wechatAuth);

        var defaultConfig = {
            appid: '',
            responseType: 'code',
            redirect_uri: '',
            error_uri: '',
            scope: 'snsapi_base ',
            getCodeCallback: function getCodeCallback() {}
        };
        this.config = (0, _assign2.default)(defaultConfig, config);
    }

    //调取微信获取code接口


    (0, _createClass3.default)(wechatAuth, [{
        key: 'getCode',
        value: function getCode() {
            var authPageBaseUri = 'https://open.weixin.qq.com/connect/oauth2/authorize';
            var authParams = '?appid=' + this.config.appid + '&redirect_uri=' + encodeURIComponent(this.config.redirectUri) + '&response_type=' + this.config.responseType + '&scope=' + this.config.scope + '#wechat_redirect';
            window.location.href = authPageBaseUri + authParams;
        }
    }, {
        key: 'next',
        value: function next(_next) {
            return function (to, code) {
                if (code) {
                    window.localStorage.setItem('wxGzhTrolleyCode', code);
                    to ? _next(to) : _next();
                } else {
                    to && _next(to);
                }
            };
        }
    }, {
        key: 'getCodeCallback',
        value: function getCodeCallback(next, code) {
            return this.config.getCodeCallback(this.next(next), code);
        }
    }]);
    return wechatAuth;
}();

exports.default = wechatAuth;

/***/ }),

/***/ "AD3X":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _safariFix = __webpack_require__("xNvf");

var _safariFix2 = _interopRequireDefault(_safariFix);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'toast',
  mixins: [_safariFix2.default],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "Bfwr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("uCgK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("Z5JB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_a79aa162_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("dnzJ");
function injectStyle (ssrContext) {
  __webpack_require__("3iZP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_a79aa162_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "DxUy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _xDialog = __webpack_require__("/kga");

var _xDialog2 = _interopRequireDefault(_xDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'confirm',
  components: {
    XDialog: _xDialog2.default
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showInput: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'ios'
    },
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    title: String,
    confirmText: String,
    cancelText: String,
    maskTransition: {
      type: String,
      default: 'vux-fade'
    },
    maskZIndex: [Number, String],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    content: String,
    closeOnConfirm: {
      type: Boolean,
      default: true
    },
    inputAttrs: Object,
    showContent: {
      type: Boolean,
      default: true
    },
    confirmType: {
      type: String,
      default: 'primary'
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    showConfirmButton: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    this.showValue = this.show;
    if (this.value) {
      this.showValue = this.value;
    }
  },

  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      var _this = this;

      this.$emit('input', val);
      if (val) {
        if (this.showInput) {
          this.msg = '';
          setTimeout(function () {
            if (_this.$refs.input) {
              _this.setInputFocus();
            }
          }, 300);
        }
        this.$emit('on-show'); // emit just after msg is cleared
      }
    }
  },
  data: function data() {
    return {
      msg: '',
      showValue: false
    };
  },

  methods: {
    getInputAttrs: function getInputAttrs() {
      return this.inputAttrs || {
        type: 'text'
      };
    },
    setInputValue: function setInputValue(val) {
      this.msg = val;
    },
    setInputFocus: function setInputFocus(evt) {
      if (evt) {
        evt.preventDefault();
      }
      this.$refs.input.focus();
    },
    _onConfirm: function _onConfirm() {
      if (!this.showValue) {
        return;
      }
      if (this.closeOnConfirm) {
        this.showValue = false;
      }
      this.$emit('on-confirm', this.msg);
    },
    _onCancel: function _onCancel() {
      if (!this.showValue) {
        return;
      }
      this.showValue = false;
      this.$emit('on-cancel');
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "Eta7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _xDialog = __webpack_require__("/kga");

var _xDialog2 = _interopRequireDefault(_xDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'alert',
  components: {
    XDialog: _xDialog2.default
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value;
    }
  },

  props: {
    value: Boolean,
    title: String,
    content: String,
    buttonText: String,
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    maskZIndex: [Number, String]
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onHide: function _onHide() {
      this.showValue = false;
    }
  },
  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "HK+o":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getWxConfig() {
    this.$http.get("http://hnjsdb.com/api/wechat/jsConfig.json?callback=_onWeChatAPIReady&url=" + encodeURIComponent(window.location.href)).then(function (_ref) {
        var data = _ref.data;

        console.log(data);
        return wx.config(data);
    });
}

exports.default = {
    getWxConfig: getWxConfig
};

/***/ }),

/***/ "IURv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-x-dialog",class:{'vux-x-dialog-absolute': _vm.layout === 'VIEW_BOX'}},[_c('transition',{attrs:{"name":_vm.maskTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-mask",style:(_vm.maskStyle),on:{"click":_vm.hide}})]),_vm._v(" "),_c('transition',{attrs:{"name":_vm.dialogTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],class:_vm.dialogClass,style:(_vm.dialogStyle)},[_vm._t("default")],2)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IcnI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__("NYxO");

var _vuex2 = _interopRequireDefault(_vuex);

var _user = __webpack_require__("bREw");

var _user2 = _interopRequireDefault(_user);

var _getters = __webpack_require__("UjVw");

var _getters2 = _interopRequireDefault(_getters);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

var store = new _vuex2.default.Store({
    modules: {
        user: _user2.default
    },
    getters: _getters2.default
});

exports.default = store;

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("bwrR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xzd6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d0b52e8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("ndG0");
function injectStyle (ssrContext) {
  __webpack_require__("zw+4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_node_modules_vux_loader_src_script_loader_js_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d0b52e8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vux_loader_src_before_template_compiler_loader_js_node_modules_vux_loader_src_template_loader_js_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "NEkW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-toast"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowMask && _vm.show),expression:"isShowMask && show"}],staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('transition',{attrs:{"name":_vm.currentTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-toast",class:_vm.toastClass,style:({width: _vm.width})},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.type !== 'text'),expression:"type !== 'text'"}],staticClass:"weui-icon-success-no-circle weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content",style:(_vm.style),domProps:{"innerHTML":_vm._s(_vm.text)}}):_c('p',{staticClass:"weui-toast__content",style:(_vm.style)},[_vm._t("default")],2)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NHnr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _fastclick = __webpack_require__("v5o6");

var _fastclick2 = _interopRequireDefault(_fastclick);

var _vueRouter = __webpack_require__("/ocq");

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _App = __webpack_require__("M93x");

var _App2 = _interopRequireDefault(_App);

var _vant = __webpack_require__("Fd2+");

var _vant2 = _interopRequireDefault(_vant);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

__webpack_require__("4ml/");

var _index = __webpack_require__("YaEn");

var _index2 = _interopRequireDefault(_index);

var _upload = __webpack_require__("f+5i");

var _upload2 = _interopRequireDefault(_upload);

var _upload3 = __webpack_require__("kZ90");

var _upload4 = _interopRequireDefault(_upload3);

var _getWxConfig = __webpack_require__("HK+o");

var _getWxConfig2 = _interopRequireDefault(_getWxConfig);

var _tool = __webpack_require__("vPHJ");

var _index3 = __webpack_require__("IcnI");

var _index4 = _interopRequireDefault(_index3);

var _weixinJsapi = __webpack_require__("SHZo");

var _weixinJsapi2 = _interopRequireDefault(_weixinJsapi);

var _index5 = __webpack_require__("n6Wb");

var _index6 = _interopRequireDefault(_index5);

var _index7 = __webpack_require__("yD8N");

var _index8 = _interopRequireDefault(_index7);

var _index9 = __webpack_require__("Y+qm");

var _index10 = _interopRequireDefault(_index9);

var _index11 = __webpack_require__("3BeM");

var _index12 = _interopRequireDefault(_index11);

var _index13 = __webpack_require__("Peep");

var _index14 = _interopRequireDefault(_index13);

var _index15 = __webpack_require__("NXWw");

var _index16 = _interopRequireDefault(_index15);

var _wechatAuth = __webpack_require__("QWsw");

var _wechatAuth2 = _interopRequireDefault(_wechatAuth);

var _auth = __webpack_require__("Pfph");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);
_vue2.default.use(_index6.default);
_vue2.default.use(_index8.default);
_vue2.default.use(_index10.default);
_vue2.default.use(_index12.default);
_vue2.default.use(_index14.default);
_vue2.default.use(_index16.default);
_vue2.default.use(_vant2.default);

_vue2.default.prototype.wx = _weixinJsapi2.default;
var query = (0, _tool.getUrlParmas)();
var url = 'http://hnjsdb.com/index.html?userid=' + query.userid;
console.log(query.userid);

/*if(query.userid){
Vue.use(wechatPlugin, {
router, // 路由实例对象
appid: 'wx4e3f4723475cf706', // 您的微信appid

responseType: 'code', // 返回类型，请填写code
scope: 'snsapi_base', // 应用授权作用域，snsapi_base （不弹出授权页面，直接跳转，只能获取用户openid），snsapi_userinfo （弹出授权页面，可通过openid拿到昵称、性别、所在地。并且，即使在未关注的情况下，只要用户授权，也能获取其信息）
redirectUri: url, //微信回调地址
getCodeCallback (next, code) {

console.log("=================code=", code);
}
})
}*/

_fastclick2.default.attach(document.body);
_vue2.default.config.productionTip = false;

_vue2.default.prototype.$upload = _upload2.default;
_vue2.default.prototype.$upload2 = _upload4.default;
_vue2.default.prototype.$wxConfig = _getWxConfig2.default;

_axios2.default.defaults.withCredentials = true;

/* eslint-disable no-new */
new _vue2.default({
  router: _index2.default,
  store: _index4.default,
  render: function render(h) {
    return h(_App2.default);
  }
}).$mount('#app-box');

(function (doc, win) {
  var docEl = doc.documentElement,
      resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
      recalc = function recalc() {
    var clientWidth = docEl.clientWidth;
    if (!clientWidth) return;
    if (clientWidth >= 750) {
      docEl.style.fontSize = '100px';
    } else {
      docEl.style.fontSize = 100 * (clientWidth / 750) + 'px';
    }
  };

  if (!doc.addEventListener) return;
  win.addEventListener(resizeEvt, recalc, false);
  doc.addEventListener('DOMContentLoaded', recalc, false);
})(document, window);

/***/ }),

/***/ "Pfph":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.login = login;
exports.register = register;
exports.imageFileUploadNoScale = imageFileUploadNoScale;

var _request = __webpack_require__("fQyU");

var _request2 = _interopRequireDefault(_request);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function login(params) {
    return (0, _request2.default)({
        url: '/api/wechat/login',
        method: 'get',
        params: params
    });
}
function register(data) {
    return (0, _request2.default)({
        url: '/api/user/register',
        method: 'post',
        type: 'json',
        data: data
    });
}
function imageFileUploadNoScale(data) {
    return (0, _request2.default)({
        url: '/api/file/imageFileUploadNoScale',
        method: 'post',
        data: data
    });
}

/***/ }),

/***/ "QWsw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _wechatAuth = __webpack_require__("9P88");

var _wechatAuth2 = _interopRequireDefault(_wechatAuth);

var _tool = __webpack_require__("vPHJ");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    install: function install(Vue, options) {
        //alert("index.js")
        var router = options.router;
        var wechatPlugin = new _wechatAuth2.default(options);
        if (!router) return false;
        //绑定到路由上
        router.beforeEach(function (to, from, next) {
            alert(to.path);
            /*if(to.path == "/index"){
                next();
                return
            }*/
            //localStorage.setItem('wxGzhTrolleyOldPath',to.fullPath)
            var query = (0, _tool.getUrlParmas)();
            var code = query.code;
            /*let wxGzhTrolleyUserInfo = window.localStorage.getItem('wxGzhTrolleyUserInfo');
            if(wxGzhTrolleyUserInfo){
                wxGzhTrolleyUserInfo = JSON.parse(wxGzhTrolleyUserInfo);
                if(wxGzhTrolleyUserInfo.exist == "false"){
                    next("/index");
                    return
                }
            }*/
            if (window.localStorage.getItem('wxGzhTrolleyCode')) {
                // 判断是否已经有授权
                next();
            } else if (code) {
                wechatPlugin.getCodeCallback(next, code);
            } else {
                //去获取code
                wechatPlugin.getCode();
            }
        });
    }
};

/***/ }),

/***/ "RMDY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TCOM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _router = __webpack_require__("0FxO");

exports.default = {
  name: 'x-button',
  props: {
    type: {
      default: 'default'
    },
    disabled: Boolean,
    mini: Boolean,
    plain: Boolean,
    text: String,
    actionType: String,
    showLoading: Boolean,
    link: [String, Object],
    gradients: {
      type: Array,
      validator: function validator(val) {
        return val.length === 2;
      }
    }
  },
  methods: {
    onClick: function onClick() {
      !this.disabled && (0, _router.go)(this.link, this.$router);
    }
  },
  computed: {
    noBorder: function noBorder() {
      return Array.isArray(this.gradients);
    },
    buttonStyle: function buttonStyle() {
      if (this.gradients) {
        return {
          background: 'linear-gradient(90deg, ' + this.gradients[0] + ', ' + this.gradients[1] + ')',
          color: '#FFFFFF'
        };
      }
    },
    classes: function classes() {
      return [{
        'weui-btn_disabled': !this.plain && this.disabled,
        'weui-btn_plain-disabled': this.plain && this.disabled,
        'weui-btn_mini': this.mini,
        'vux-x-button-no-border': this.noBorder
      }, !this.plain ? 'weui-btn_' + this.type : '', this.plain ? 'weui-btn_plain-' + this.type : '', this.showLoading ? 'weui-btn_loading' : ''];
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "TRD7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-confirm"},[_c('x-dialog',{attrs:{"dialog-class":_vm.theme === 'android' ? 'weui-dialog weui-skin_android' : 'weui-dialog',"mask-transition":_vm.maskTransition,"dialog-transition":_vm.theme === 'android' ? 'vux-fade' : _vm.dialogTransition,"hide-on-blur":_vm.hideOnBlur,"mask-z-index":_vm.maskZIndex},on:{"on-hide":function($event){return _vm.$emit('on-hide')}},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[(!!_vm.title)?_c('div',{staticClass:"weui-dialog__hd",class:{'with-no-content': !_vm.showContent}},[_c('strong',{staticClass:"weui-dialog__title"},[_vm._v(_vm._s(_vm.title))])]):_vm._e(),_vm._v(" "),(_vm.showContent)?[(!_vm.showInput)?_c('div',{staticClass:"weui-dialog__bd"},[_vm._t("default",function(){return [_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})]})],2):_c('div',{staticClass:"vux-prompt"},[(((_vm.getInputAttrs()).type)==='checkbox')?_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.msg)?_vm._i(_vm.msg,null)>-1:(_vm.msg)},on:{"touchend":_vm.setInputFocus,"change":function($event){var $$a=_vm.msg,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.msg=$$a.concat([$$v]))}else{$$i>-1&&(_vm.msg=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.msg=$$c}}}},'input',_vm.getInputAttrs(),false)):(((_vm.getInputAttrs()).type)==='radio')?_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":"radio"},domProps:{"checked":_vm._q(_vm.msg,null)},on:{"touchend":_vm.setInputFocus,"change":function($event){_vm.msg=null}}},'input',_vm.getInputAttrs(),false)):_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":(_vm.getInputAttrs()).type},domProps:{"value":(_vm.msg)},on:{"touchend":_vm.setInputFocus,"input":function($event){if($event.target.composing){ return; }_vm.msg=$event.target.value}}},'input',_vm.getInputAttrs(),false))])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"weui-dialog__ft"},[(_vm.showCancelButton)?_c('a',{staticClass:"weui-dialog__btn weui-dialog__btn_default",attrs:{"href":"javascript:;"},on:{"click":_vm._onCancel}},[_vm._v(_vm._s(_vm.cancelText || '取消'))]):_vm._e(),_vm._v(" "),(_vm.showConfirmButton)?_c('a',{staticClass:"weui-dialog__btn",class:("weui-dialog__btn_" + _vm.confirmType),attrs:{"href":"javascript:;"},on:{"click":_vm._onConfirm}},[_vm._v(_vm._s(_vm.confirmText || '确定'))]):_vm._e()])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UjVw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var getters = {
    userInfo: function userInfo(state) {
        return state.user.userInfo;
    },
    appId: function appId(state) {
        return state.user.appId;
    },
    imgPatch: function imgPatch(state) {
        return state.user.imgPatch;
    }
};
exports.default = getters;

/***/ }),

/***/ "YaEn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.constantRoutes = undefined;
exports.resetRouter = resetRouter;

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__("/ocq");

var _vueRouter2 = _interopRequireDefault(_vueRouter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);

var VueRouterPush = _vueRouter2.default.prototype.push;
_vueRouter2.default.prototype.push = function push(to) {
    return VueRouterPush.call(this, to).catch(function (err) {
        return err;
    });
};

var constantRoutes = exports.constantRoutes = [{ path: '/', name: 'header', redirect: '/index?userid=' + window.localStorage.getItem('userid'), component: function component() {
        return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, "8Gwg"));
    }, children: [{ path: '/index', name: 'index', component: function component() {
            return Promise.all/* import() */([__webpack_require__.e(3), __webpack_require__.e(0)]).then(__webpack_require__.bind(null, "8hXn"));
        } }, //公司简介
    { path: '/guarantee', name: 'guarantee', component: function component() {
            return Promise.all/* import() */([__webpack_require__.e(2), __webpack_require__.e(0)]).then(__webpack_require__.bind(null, "2NXY"));
        } }, //保函查询
    { path: '/intention', name: 'intention', component: function component() {
            return Promise.all/* import() */([__webpack_require__.e(1), __webpack_require__.e(0)]).then(__webpack_require__.bind(null, "QEqD"));
        } }] }];
var createRouter = function createRouter() {
    return new _vueRouter2.default({
        scrollBehavior: function scrollBehavior() {
            return { y: 0 };
        },
        routes: constantRoutes
    });
};

var router = createRouter();

function resetRouter() {
    var newRouter = createRouter();
    router.matcher = newRouter.matcher; // reset router
}

exports.default = router;

/***/ }),

/***/ "Z5JB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
};

/***/ }),

/***/ "bREw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var wxGzhTrolleyUserInfo = localStorage.getItem("wxGzhTrolleyUserInfo") || "{}";
var state = {
    userInfo: JSON.parse(wxGzhTrolleyUserInfo),
    appId: "wx4e3f4723475cf706", // 生产
    // appId: "wx645f528c1360a2fa", //测试
    imgPatch: './api/file/showImg?fileName='
};

var mutations = {
    SET_USERINFO: function SET_USERINFO(state, userInfo) {
        state.userInfo = userInfo;
    }
};

var actions = {};

exports.default = {
    namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions
};

/***/ }),

/***/ "bwrR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__("NYxO");

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _index = __webpack_require__("2sLL");

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('x-button', _index2.default);

exports.default = {
  name: 'app',
  provide: function provide() {
    return {
      reload: this.reload
    };
  },

  components: {},
  computed: {},
  data: function data() {
    return {
      isRouterAlive: true
    };
  },

  methods: {
    reload: function reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    }
  }
};

/***/ }),

/***/ "cvA0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _preventBodyScroll = __webpack_require__("JkZY");

var _preventBodyScroll2 = _interopRequireDefault(_preventBodyScroll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_preventBodyScroll2.default],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "dnzJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.transition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-loading_toast vux-loading",class:!_vm.text ? 'vux-loading-no-text' : ''},[_c('div',{staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('div',{staticClass:"weui-toast",style:({
        position: _vm.position
      })},[_c('i',{staticClass:"weui-loading weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content"},[_vm._v(_vm._s(_vm.text || '加载中')),_vm._t("default")],2):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "f+5i":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _index = __webpack_require__("IcnI");

var _index2 = _interopRequireDefault(_index);

var _imageCompressor = __webpack_require__("VDWi");

var _imageCompressor2 = _interopRequireDefault(_imageCompressor);

var _myCar = __webpack_require__("29CB");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var imgPatch = _index2.default.state.user.imgPatch;
var imgFiles = []; // 图片原文件
// let imgs = []; // 图片预览地址
var imgFilesUrl = []; // 上传成功后回调的图片路径
var imgFilesUrlOrg = []; // 上传成功后回调的图片路径
function fileChange(type) {
    // 加入图片
    var event = event || window.event;
    var file = event.target.files;
    var leng = file.length;
    // var img = e.target.result;
    for (var i = 0; i < leng; i++) {
        imgFiles.push(file[i]);
        // alert(file[i].size)
        compressImage(file[i]).then(function (res) {
            // alert(res.size)
            var reader = new FileReader(); // 使用 FileReader 来获取图片路径及预览效果
            reader.readAsDataURL(res);
            reader.onload = function (e) {
                fileUp(e.target.result, type);
                // imgs.push(e.target.result); // base 64 图片地址形成预览
            };
        });
    }
    // console.log(imgFilesUrl)
    // console.log(imgFilesUrlOrg)
}
function compressImage(file) {
    return new _promise2.default(function (resolve, reject) {
        new _imageCompressor2.default(file, {
            quality: 0.4,
            checkOrientation: false,
            success: function success(result) {
                resolve(result);
            },
            error: function error(e) {
                reject();
            }
        });
    });
}
function del(i) {
    // console.log(i);
    fileDel(i);
}

function fileUp(data, type) {
    var _this = this;

    // type : 1、身份证；2、电动车、3：线索
    (0, _myCar.uploadFileBase)({
        file: data,
        type: type
    }).then(function (res) {
        if (res.code == '0') {
            imgFilesUrlOrg.push(res.data);
            // 'http://localhost:8091/ev-wechat/file?fileName='
            var a = {
                src: imgPatch + res.data.src,
                msrc: imgPatch + res.data.msrc
            };
            imgFilesUrl.push(a);

            // console.log(imgFilesUrl)
            // console.log(imgFilesUrlOrg)
        } else {
            _this.$vux.toast.text(res.desc, 'center');
        }
    });
}
function fileDel(i) {
    var _this2 = this;

    // console.log(i)
    // console.log(imgFilesUrl)
    // console.log(imgFilesUrlOrg)
    (0, _myCar.removeImg)({
        fileName: imgFilesUrl[i].msrc
    }).then(function (res) {
        if (res.code == '0') {
            // 根据下标删除
            imgFiles.splice(i, 1);
            // imgs.splice(i, 1);
            imgFilesUrl.splice(i, 1);
            imgFilesUrlOrg.splice(i, 1);
        } else {
            _this2.$vux.toast.text(res.desc, 'top');
        }
    });
}
function clear() {
    imgFiles.splice(0, imgFiles.length);
    imgFilesUrl.splice(0, imgFilesUrl.length);
    imgFilesUrlOrg.splice(0, imgFilesUrlOrg.length);
    console.log('0', imgFilesUrl);
    console.log('0', imgFilesUrlOrg);
}

function potArry(data1, data2) {
    imgFilesUrl = data1;
    imgFilesUrlOrg = data2;
    // console.log(imgFilesUrl)
    // console.log(imgFilesUrlOrg)
}

exports.default = {
    imgFilesUrl: imgFilesUrl,
    imgFilesUrlOrg: imgFilesUrlOrg,
    // imgFiles,
    // imgs,
    fileChange: fileChange,
    del: del,
    clear: clear,
    potArry: potArry
};

/***/ }),

/***/ "fQyU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

var _store = __webpack_require__("IcnI");

var _store2 = _interopRequireDefault(_store);

var _qs = __webpack_require__("mw3O");

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//设置全局的请求次数，请求的间隙
_axios2.default.defaults.retry = 0;
_axios2.default.defaults.retryDelay = 1000;
// create an axios instance
var service = _axios2.default.create({
    baseURL: "http://hnjsdb.com/api", // url = base url + request url
    withCredentials: true, // send cookies when cross-domain requests
    timeout: 10000 // request timeout
});
// request interceptor
service.interceptors.request.use(function (config) {
    // do something before request is sent
    if (config.type != 'json') {
        config.headers['content-type'] = 'application/x-www-form-urlencoded';
        config.data = _qs2.default.stringify(config.data);
    } else {
        config.headers['content-type'] = 'application/json';
    }
    return config;
}, function (error) {
    // do something with request error
    _vue2.default.$vux.toast.text(error, "center");
    console.log(error); // for debug
    return _promise2.default.reject(error);
});

// response interceptor
service.interceptors.response.use(
/**
 * If you want to get http information such as headers or status
 * Please return  response => response
 */

/**
 * Determine the request status by custom code
 * Here is just an example
 * You can also judge the status by HTTP Status Code
 */
function (response) {
    // console.log(response.data)
    var res = response.data;

    // Vue.$vux.toast.text(res.desc, "center");

    // if the custom code is not 20000, it is judged as an error.
    if (res.code && res.code != 0) {
        if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
            // Vue.$vux.toast.text(res.desc, "center");
        }
        if (res.code == "-1000") {
            localStorage.removeItem("wxGzhTrolleyUserInfo");
            localStorage.removeItem("wxGzhTrolleyCode");
            window.location.href = "http://hnjsdb.com/api" + '#' + localStorage.getItem('wxGzhTrolleyOldPath');
        }
        // return Promise.reject(new Error(res.desc || 'Error'))
        return _promise2.default.reject(res);
    } else {
        return res;
    }
}, function (error) {
    return _promise2.default.reject({ desc: '网络异常' });

    // if (error.response && error.response.status && error.response.status == "401") {
    //     // store.dispatch('user/logout').then(() => {
    //     //     location.reload()
    //     // })
    // }
    // // return Promise.reject(error)
    // var config = error.config;
    // // If config does not exist or the retry option is not set, reject
    // if (!config || !config.retry) return Promise.reject(error);

    // // Set the variable for keeping track of the retry count
    // config.__retryCount = config.__retryCount || 0;

    // // Check if we've maxed out the total number of retries
    // if (config.__retryCount >= config.retry) {
    //     // Reject with the error
    //     return Promise.reject(error);
    // }

    // // Increase the retry count
    // config.__retryCount += 1;

    // // Create new promise to handle exponential backoff
    // var backoff = new Promise(function (resolve) {
    //     setTimeout(function () {
    //         config.baseURL = ""
    //         resolve();
    //     }, config.retryDelay || 1);
    // });

    // // Return the promise in which recalls axios to retry the request
    // return backoff.then(function () {
    //     return service(config);
    // })
});

exports.default = service;

/***/ }),

/***/ "kZ90":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _index = __webpack_require__("IcnI");

var _index2 = _interopRequireDefault(_index);

var _imageCompressor = __webpack_require__("VDWi");

var _imageCompressor2 = _interopRequireDefault(_imageCompressor);

var _myCar = __webpack_require__("29CB");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var imgPatch = _index2.default.state.user.imgPatch;
var imgFiles = []; // 图片原文件
// let imgs = []; // 图片预览地址
var imgFilesUrl = []; // 上传成功后回调的图片路径
var imgFilesUrlOrg = []; // 上传成功后回调的图片路径
function fileChange(type) {
    // 加入图片
    var event = event || window.event;
    var file = event.target.files;
    var leng = file.length;
    // var img = e.target.result;
    for (var i = 0; i < leng; i++) {
        imgFiles.push(file[i]);
        // alert(file[i].size)
        compressImage(file[i]).then(function (res) {
            // alert(res.size)
            var reader = new FileReader(); // 使用 FileReader 来获取图片路径及预览效果
            reader.readAsDataURL(res);
            reader.onload = function (e) {
                fileUp(e.target.result, type);
                // imgs.push(e.target.result); // base 64 图片地址形成预览
            };
        });
    }
    // console.log(imgFilesUrl)
    // console.log(imgFilesUrlOrg)
}
function compressImage(file) {
    return new _promise2.default(function (resolve, reject) {
        new _imageCompressor2.default(file, {
            quality: 0.4,
            checkOrientation: false,
            success: function success(result) {
                resolve(result);
            },
            error: function error(e) {
                reject();
            }
        });
    });
}
function del(i) {
    // console.log(i);
    fileDel(i);
}

function fileUp(data, type) {
    var _this = this;

    // type : 1、身份证；2、电动车、3：线索
    (0, _myCar.uploadFileBase)({
        file: data,
        type: type
    }).then(function (res) {
        if (res.code == '0') {
            imgFilesUrlOrg.push(res.data);
            // 'http://localhost:8091/ev-wechat/file?fileName='
            var a = {
                src: imgPatch + res.data.src,
                msrc: imgPatch + res.data.msrc
            };
            imgFilesUrl.push(a);

            console.log(imgFilesUrl);
            console.log(imgFilesUrlOrg);
        } else {
            _this.$vux.toast.text(res.desc, 'center');
        }
    });
}
function fileDel(i) {
    var _this2 = this;

    // console.log(imgFilesUrl[i])
    // console.log(imgFilesUrl[i].msrc)
    (0, _myCar.removeImg)({
        fileName: imgFilesUrl[i].msrc
    }).then(function (res) {
        if (res.code == '0') {
            // 根据下标删除
            imgFiles.splice(i, 1);
            // imgs.splice(i, 1);
            imgFilesUrl.splice(i, 1);
            imgFilesUrlOrg.splice(i, 1);
        } else {
            _this2.$vux.toast.text(res.desc, 'top');
        }
    });
}
function clear() {
    imgFiles.splice(0, imgFiles.length);
    imgFilesUrl.splice(0, imgFilesUrl.length);
    imgFilesUrlOrg.splice(0, imgFilesUrlOrg.length);
    console.log('0', imgFilesUrl);
    console.log('0', imgFilesUrlOrg);
}

function potArry(data1, data2) {
    imgFilesUrl = data1;
    imgFilesUrlOrg = data2;
}

exports.default = {
    imgFilesUrl: imgFilesUrl,
    imgFilesUrlOrg: imgFilesUrlOrg,
    // imgFiles,
    // imgs,
    fileChange: fileChange,
    del: del,
    clear: clear,
    potArry: potArry
};

/***/ }),

/***/ "kllH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mzja":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("Eta7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("2RPQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_0222073a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("rB/o");
function injectStyle (ssrContext) {
  __webpack_require__("55wj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_0222073a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "nQpb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _safariFix = __webpack_require__("xNvf");

var _safariFix2 = _interopRequireDefault(_safariFix);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'toast',
  mixins: [_safariFix2.default],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "ndG0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.isRouterAlive)?_c('router-view'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nnSp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rB/o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-alert"},[_c('x-dialog',{attrs:{"mask-transition":_vm.maskTransition,"dialog-transition":_vm.dialogTransition,"hide-on-blur":_vm.hideOnBlur,"mask-z-index":_vm.maskZIndex},on:{"on-hide":function($event){return _vm.$emit('on-hide')},"on-show":function($event){return _vm.$emit('on-show')}},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[_c('div',{staticClass:"weui-dialog__hd"},[_c('strong',{staticClass:"weui-dialog__title"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',{staticClass:"weui-dialog__bd"},[_vm._t("default",function(){return [_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})]})],2),_vm._v(" "),_c('div',{staticClass:"weui-dialog__ft"},[_c('a',{staticClass:"weui-dialog__btn weui-dialog__btn_primary",attrs:{"href":"javascript:;"},on:{"click":_vm._onHide}},[_vm._v(_vm._s(_vm.buttonText || '确定'))])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rLAy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("AD3X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vux_loader_src_script_loader_js_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("nQpb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_25afd1ad_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("NEkW");
function injectStyle (ssrContext) {
  __webpack_require__("kllH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_1__babel_loader_vux_loader_src_script_loader_js_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_template_compiler_index_id_data_v_25afd1ad_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vux_loader_src_before_template_compiler_loader_js_vux_loader_src_template_loader_js_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "uCgK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
};

/***/ }),

/***/ "vPHJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var getUrlParmas = exports.getUrlParmas = function getUrlParmas() {
    var url = location.search; //获取url中"?"符后的字串
    var theRequest = new Object();
    if (url.indexOf("?") != -1) {
        var str = url.substr(1);
        var strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
            theRequest[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1]);
        }
    }
    return theRequest;
};

/***/ }),

/***/ "vjYW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _router = __webpack_require__("0FxO");

exports.default = {
  name: 'x-button',
  props: {
    type: {
      default: 'default'
    },
    disabled: Boolean,
    mini: Boolean,
    plain: Boolean,
    text: String,
    actionType: String,
    showLoading: Boolean,
    link: [String, Object],
    gradients: {
      type: Array,
      validator: function validator(val) {
        return val.length === 2;
      }
    }
  },
  methods: {
    onClick: function onClick() {
      !this.disabled && (0, _router.go)(this.link, this.$router);
    }
  },
  computed: {
    noBorder: function noBorder() {
      return Array.isArray(this.gradients);
    },
    buttonStyle: function buttonStyle() {
      if (this.gradients) {
        return {
          background: 'linear-gradient(90deg, ' + this.gradients[0] + ', ' + this.gradients[1] + ')',
          color: '#FFFFFF'
        };
      }
    },
    classes: function classes() {
      return [{
        'weui-btn_disabled': !this.plain && this.disabled,
        'weui-btn_plain-disabled': this.plain && this.disabled,
        'weui-btn_mini': this.mini,
        'vux-x-button-no-border': this.noBorder
      }, !this.plain ? 'weui-btn_' + this.type : '', this.plain ? 'weui-btn_plain-' + this.type : '', this.showLoading ? 'weui-btn_loading' : ''];
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "xzd6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__("NYxO");

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _index = __webpack_require__("2sLL");

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('x-button', _index2.default);

exports.default = {
  name: 'app',
  provide: function provide() {
    return {
      reload: this.reload
    };
  },

  components: {},
  computed: {},
  data: function data() {
    return {
      isRouterAlive: true
    };
  },

  methods: {
    reload: function reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    }
  }
};

/***/ }),

/***/ "zw+4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.cd4920631cad6939c0381661208442500.js